import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedComponent } from './shared';
import { TooltipOnEllipsisV2Directive, OutSideClickDirective } from './directive';
import * as i0 from "@angular/core";
export class SharedModule {
  injector;
  static injector;
  constructor(injector) {
    this.injector = injector;
    SharedModule.injector = injector;
  }
  static ɵfac = function SharedModule_Factory(t) {
    return new (t || SharedModule)(i0.ɵɵinject(i0.Injector));
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SharedModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedModule, [{
    type: NgModule,
    args: [{
      declarations: [SharedComponent, TooltipOnEllipsisV2Directive, OutSideClickDirective],
      imports: [CommonModule],
      exports: [SharedComponent, TooltipOnEllipsisV2Directive, OutSideClickDirective]
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();
